export default function getLiElementId(target: HTMLElement): string | null {
    const tag = target?.tagName;
    if (!tag || tag === 'BODY') return null;
    if (tag === 'LI') {
        return target.id;
    } else {
        const elem = target.parentElement;
        if (!elem) return null;
        else return getLiElementId(elem);
    }
}
